import { defineMessages } from './define'

/* The desk's money screens: billing, the day-end drawer count and reports.
 * Printed invoices and receipts stay in English and are not here. */

export default defineMessages({
  en: {
    'money.collectedToday': 'Collected today',
    'money.reconciliation': 'Reconciliation',
    'money.pendingN': '{n} pending',
    'money.dueAcross': '{amount} due across visits',
    'money.viewBills': 'View bills',
    // billing list
    'money.billing': 'Billing',
    'money.raiseBill': 'Raise a bill',
    'money.filter.owing': 'Outstanding',
    'money.filter.draft': 'Drafts',
    'money.filter.finalised': 'Finalised',
    'money.invStatus.draft': 'draft',
    'money.invStatus.finalised': 'finalised',
    'money.invStatus.void': 'void',
    'money.outstanding': 'Outstanding',
    'money.billsLabel_one': 'Bill',
    'money.billsLabel_other': 'Bills',
    'money.loadingBills': 'Loading bills…',
    'money.noBills': 'No bills here.',
    'money.noBillsBody': 'Raise one to start.',
    'money.rowTotal': 'Total {amount}',
    'money.rowPaid': 'Paid {amount}',
    'money.rowRefunded': 'Refunded {amount}',
    'money.rowDue': 'Due {amount}',
    'money.couldNotLoadBills': 'Could not load bills.',
    'money.couldNotOpenBill': 'Could not open the bill.',
    // bill figures and line editor
    'money.items': 'Items',
    'money.tax': 'Tax',
    'money.item': 'Item',
    'money.itemPh': 'Consultation, dressing, injection…',
    'money.quantity': 'Quantity',
    'money.rate': 'Rate',
    'money.taxPct': 'Tax %',
    'money.addLine': 'Add a line',
    // raising a bill
    'money.choosePatientFirst': 'Choose the patient first.',
    'money.couldNotRaise': 'Could not raise the bill.',
    'money.raising': 'Raising…',
    'money.raiseAsDraft': 'Raise as draft · {amount}',
    'money.change': 'Change',
    'money.patientPh': 'Name, mobile or patient code',
    'money.wholeBillDiscount': 'Discount on the whole bill',
    'money.notNeeded': 'Not needed',
    'money.draftNote': 'Raised as a draft. Read it back to the patient, then finalise it — after that the figures are fixed and it can take payment.',
    // one bill
    'money.pricingSaved': 'Pricing saved.',
    'money.couldNotSavePricing': 'Could not save the pricing.',
    'money.billFinalised': '{no} finalised.',
    'money.couldNotFinalise': 'Could not finalise the bill.',
    'money.voidPrompt': 'Why is this bill being voided?',
    'money.billVoided': 'Bill voided.',
    'money.couldNotVoid': 'Could not void the bill.',
    'money.tookAmount': 'Took {amount}.',
    'money.couldNotRecordPayment': 'Could not record the payment.',
    'money.refundedAmount': 'Refunded {amount}.',
    'money.couldNotRecordRefund': 'Could not record the refund.',
    'money.savePricing': 'Save pricing',
    'money.editPricing': 'Edit pricing',
    'money.billDiscount': 'Discount on the bill',
    'money.billDiscountReason': 'Discount on the bill: {reason}',
    'money.voided': 'Voided.',
    'money.voidedReason': 'Voided: {reason}.',
    'money.lineLess': 'less {amount}',
    'money.lineTax': 'tax {amount} ({rate}%)',
    'money.draftCannotPay': 'A draft cannot take payment. Finalise it to start collecting.',
    'money.finaliseBill': 'Finalise bill',
    'money.voidBill': 'Void this bill',
    'money.received': 'Received',
    'money.lessRefunded': 'less {amount} refunded',
    'money.refund': 'Refund',
    'money.refunded': 'Refunded',
    'money.noReason': 'No reason recorded',
    'money.settled': 'Settled',
    'money.refundNote': 'The receipt is never altered. The refund is recorded against it as a separate entry and the balance reopens by that much.',
    'money.recordRefund': 'Record refund',
    'money.takePayment': 'Take a payment',
    'money.mode': 'Mode',
    'money.cashReceived': 'Cash received',
    'money.referenceNo': 'Reference no.',
    'money.cashReceivedPh': 'What the patient handed over',
    'money.referencePh': 'UTR, approval code, cheque no.',
    'money.changeBack': 'Change to hand back: {amount}',
    'money.lessThanAmount': 'That is less than the amount being paid.',
    'money.partPayment': 'A part payment. {amount} would remain outstanding.',
    'money.payAll': 'Pay it all',
    'money.recording': 'Recording…',
    'money.takeAmount': 'Take {amount}',
    // day end
    'money.dayEnd': 'Day end',
    'money.reload': 'Reload',
    'money.couldNotLoadTally': 'Could not load the tally.',
    'money.counting': 'Counting…',
    'money.collected': 'Collected',
    'money.payments': 'Payments',
    'money.inDrawer': 'In the drawer',
    'money.byMode': 'By payment mode',
    'money.nothingCollectedDay': 'Nothing collected on this day.',
    'money.paymentsCount_one': '{n} payment',
    'money.paymentsCount_other': '{n} payments',
    'money.refundsCount_one': '{n} refund',
    'money.refundsCount_other': '{n} refunds',
    'money.netOfRefunds': 'Net of refunds',
    'money.countDrawer': 'Count the drawer',
    'money.cashTaken': 'Cash taken',
    'money.cashRefunded': 'Cash refunded',
    'money.shouldBeInDrawer': 'Should be in the drawer',
    'money.countedInDrawer': 'Counted in the drawer',
    'money.countedPh': 'Count the notes and enter the total',
    'money.drawerBalances': 'The drawer balances.',
    'money.drawerOver': '{amount} more than the books. Look for a receipt that was never written.',
    'money.drawerShort': '{amount} short. Look for change given without a receipt, or a payment recorded but not collected.',
    'money.drawerNote': 'Card, UPI and net banking settle with the bank rather than the drawer, so they are listed above but not counted here.',
    // reports
    'money.reports': 'Reports',
    'money.couldNotLoadReports': 'Could not load the reports.',
    'money.days7': '7 days',
    'money.days30': '30 days',
    'money.custom': 'Custom',
    'money.from': 'From',
    'money.to': 'To',
    'money.completedCount': '{n} completed',
    'money.newVsReturning': '{newPct}% new · {retPct}% returning',
    'money.byDoctor': 'By doctor',
    'money.practice': 'Practice',
    'money.dues': 'Dues',
    'money.noVisitsRange': 'No visits in this range.',
    'money.visitsCount_one': '{n} visit',
    'money.visitsCount_other': '{n} visits',
    'money.paymentMix': 'Payment mix',
    'money.nothingCollectedYet': 'Nothing collected yet.',
    'money.visitType': 'Visit type',
    'money.waitConsult': 'Wait and consultation',
    'money.waitNote': 'Averages over completed visits. Wait is arrived to in-consult; consult is in-consult to signed.',
    'money.noTimings': 'No timings yet — the report needs visits that reached in-consult and signed.',
    'money.consultsCount_one': '{n} consult',
    'money.consultsCount_other': '{n} consults',
    'money.waitConsultMin': 'wait / consult (min)',
    'money.topDiagnoses': 'Most frequent diagnoses',
    'money.noDiagnoses': 'No signed diagnoses yet.',
    'money.topTests': 'Most ordered tests',
    'money.noTests': 'No tests advised in this range.',
    'money.topMedicines': 'Most prescribed medicines',
    'money.noMedicines': 'No prescriptions in this range.',
    'money.outstandingDues': 'Outstanding dues',
    'money.totalAmount': 'total {amount}',
    'money.nothingOwing': 'Nothing owing.',
    'money.ofAmount': 'of {amount}',
  },
  hi: {
    'money.collectedToday': 'आज जमा',
    'money.reconciliation': 'मिलान',
    'money.pendingN': '{n} बाकी',
    'money.dueAcross': 'विज़िट पर {amount} बाकी',
    'money.viewBills': 'बिल देखें',
    'money.billing': 'बिलिंग',
    'money.raiseBill': 'बिल बनाएँ',
    'money.filter.owing': 'बकाया',
    'money.filter.draft': 'ड्राफ़्ट',
    'money.filter.finalised': 'फ़ाइनल',
    'money.invStatus.draft': 'ड्राफ़्ट',
    'money.invStatus.finalised': 'फ़ाइनल',
    'money.invStatus.void': 'रद्द',
    'money.outstanding': 'बकाया',
    'money.billsLabel_one': 'बिल',
    'money.billsLabel_other': 'बिल',
    'money.loadingBills': 'बिल लोड हो रहे हैं…',
    'money.noBills': 'यहाँ कोई बिल नहीं है।',
    'money.noBillsBody': 'शुरू करने के लिए एक बिल बनाएँ।',
    'money.rowTotal': 'कुल {amount}',
    'money.rowPaid': 'भुगतान {amount}',
    'money.rowRefunded': 'रिफ़ंड {amount}',
    'money.rowDue': 'बकाया {amount}',
    'money.couldNotLoadBills': 'बिल लोड नहीं हो सके।',
    'money.couldNotOpenBill': 'बिल खुल नहीं सका।',
    'money.items': 'आइटम',
    'money.tax': 'टैक्स',
    'money.item': 'आइटम',
    'money.itemPh': 'कंसल्टेशन, ड्रेसिंग, इंजेक्शन…',
    'money.quantity': 'मात्रा',
    'money.rate': 'दर',
    'money.taxPct': 'टैक्स %',
    'money.addLine': 'एक लाइन जोड़ें',
    'money.choosePatientFirst': 'पहले मरीज़ चुनें।',
    'money.couldNotRaise': 'बिल नहीं बन सका।',
    'money.raising': 'बिल बन रहा है…',
    'money.raiseAsDraft': 'ड्राफ़्ट के रूप में बनाएँ · {amount}',
    'money.change': 'बदलें',
    'money.patientPh': 'नाम, मोबाइल या मरीज़ कोड',
    'money.wholeBillDiscount': 'पूरे बिल पर छूट',
    'money.notNeeded': 'ज़रूरी नहीं',
    'money.draftNote': 'यह ड्राफ़्ट के रूप में बना है। मरीज़ को पढ़कर सुनाएँ, फिर इसे फ़ाइनल करें — उसके बाद राशियाँ तय हो जाती हैं और भुगतान लिया जा सकता है।',
    'money.pricingSaved': 'कीमतें सेव हो गईं।',
    'money.couldNotSavePricing': 'कीमतें सेव नहीं हो सकीं।',
    'money.billFinalised': '{no} फ़ाइनल हो गया।',
    'money.couldNotFinalise': 'बिल फ़ाइनल नहीं हो सका।',
    'money.voidPrompt': 'यह बिल क्यों रद्द किया जा रहा है?',
    'money.billVoided': 'बिल रद्द हो गया।',
    'money.couldNotVoid': 'बिल रद्द नहीं हो सका।',
    'money.tookAmount': '{amount} लिए गए।',
    'money.couldNotRecordPayment': 'भुगतान दर्ज नहीं हो सका।',
    'money.refundedAmount': '{amount} रिफ़ंड किए गए।',
    'money.couldNotRecordRefund': 'रिफ़ंड दर्ज नहीं हो सका।',
    'money.savePricing': 'कीमतें सेव करें',
    'money.editPricing': 'कीमतें बदलें',
    'money.billDiscount': 'बिल पर छूट',
    'money.billDiscountReason': 'बिल पर छूट: {reason}',
    'money.voided': 'रद्द किया गया।',
    'money.voidedReason': 'रद्द किया गया: {reason}।',
    'money.lineLess': '{amount} कम',
    'money.lineTax': 'टैक्स {amount} ({rate}%)',
    'money.draftCannotPay': 'ड्राफ़्ट पर भुगतान नहीं लिया जा सकता। भुगतान लेने के लिए इसे फ़ाइनल करें।',
    'money.finaliseBill': 'बिल फ़ाइनल करें',
    'money.voidBill': 'यह बिल रद्द करें',
    'money.received': 'प्राप्त',
    'money.lessRefunded': '{amount} रिफ़ंड घटाकर',
    'money.refund': 'रिफ़ंड',
    'money.refunded': 'रिफ़ंड किया गया',
    'money.noReason': 'कोई कारण दर्ज नहीं',
    'money.settled': 'चुकता',
    'money.refundNote': 'रसीद कभी बदली नहीं जाती। रिफ़ंड उसके सामने अलग एंट्री के रूप में दर्ज होता है और बकाया उतनी राशि से फिर खुल जाता है।',
    'money.recordRefund': 'रिफ़ंड दर्ज करें',
    'money.takePayment': 'भुगतान लें',
    'money.mode': 'तरीका',
    'money.cashReceived': 'मिला हुआ नकद',
    'money.referenceNo': 'रेफ़रेंस नंबर',
    'money.cashReceivedPh': 'मरीज़ ने कितने पैसे दिए',
    'money.referencePh': 'UTR, अप्रूवल कोड, चेक नंबर',
    'money.changeBack': 'वापस देने के छुट्टे: {amount}',
    'money.lessThanAmount': 'यह भुगतान की जा रही राशि से कम है।',
    'money.partPayment': 'आंशिक भुगतान। {amount} बकाया रहेगा।',
    'money.payAll': 'पूरा भुगतान',
    'money.recording': 'दर्ज हो रहा है…',
    'money.takeAmount': '{amount} लें',
    'money.dayEnd': 'दिन का हिसाब',
    'money.reload': 'फिर से लोड करें',
    'money.couldNotLoadTally': 'हिसाब लोड नहीं हो सका।',
    'money.counting': 'गिनती हो रही है…',
    'money.collected': 'कलेक्शन',
    'money.payments': 'भुगतान',
    'money.inDrawer': 'दराज़ में',
    'money.byMode': 'भुगतान के तरीके अनुसार',
    'money.nothingCollectedDay': 'इस दिन कोई कलेक्शन नहीं हुआ।',
    'money.paymentsCount_one': '{n} भुगतान',
    'money.paymentsCount_other': '{n} भुगतान',
    'money.refundsCount_one': '{n} रिफ़ंड',
    'money.refundsCount_other': '{n} रिफ़ंड',
    'money.netOfRefunds': 'रिफ़ंड घटाकर',
    'money.countDrawer': 'दराज़ गिनें',
    'money.cashTaken': 'लिया गया नकद',
    'money.cashRefunded': 'लौटाया गया नकद',
    'money.shouldBeInDrawer': 'दराज़ में होना चाहिए',
    'money.countedInDrawer': 'दराज़ में गिना गया',
    'money.countedPh': 'नोट गिनें और कुल राशि लिखें',
    'money.drawerBalances': 'दराज़ का हिसाब मिल गया।',
    'money.drawerOver': 'हिसाब से {amount} ज़्यादा। कोई ऐसी रसीद देखें जो बनाई ही नहीं गई।',
    'money.drawerShort': '{amount} कम। बिना रसीद के दिए गए छुट्टे देखें, या ऐसा भुगतान जो दर्ज हुआ पर लिया नहीं गया।',
    'money.drawerNote': 'कार्ड, UPI और नेट बैंकिंग का हिसाब दराज़ से नहीं, बैंक से होता है, इसलिए वे ऊपर दिखते हैं पर यहाँ गिने नहीं जाते।',
    'money.reports': 'रिपोर्ट',
    'money.couldNotLoadReports': 'रिपोर्ट लोड नहीं हो सकीं।',
    'money.days7': '7 दिन',
    'money.days30': '30 दिन',
    'money.custom': 'अपनी तारीखें',
    'money.from': 'से',
    'money.to': 'तक',
    'money.completedCount': '{n} पूरी हुईं',
    'money.newVsReturning': '{newPct}% नए · {retPct}% पुराने',
    'money.byDoctor': 'डॉक्टर अनुसार',
    'money.practice': 'प्रैक्टिस',
    'money.dues': 'बकाया',
    'money.noVisitsRange': 'इस अवधि में कोई विज़िट नहीं।',
    'money.visitsCount_one': '{n} विज़िट',
    'money.visitsCount_other': '{n} विज़िट',
    'money.paymentMix': 'भुगतान के तरीके',
    'money.nothingCollectedYet': 'अभी तक कोई कलेक्शन नहीं।',
    'money.visitType': 'विज़िट का प्रकार',
    'money.waitConsult': 'इंतज़ार और कंसल्टेशन',
    'money.waitNote': 'पूरी हुई विज़िट का औसत। इंतज़ार = पहुँचने से कंसल्टेशन शुरू होने तक; कंसल्टेशन = शुरू होने से साइन होने तक।',
    'money.noTimings': 'अभी कोई समय नहीं — रिपोर्ट के लिए ऐसी विज़िट चाहिए जो कंसल्टेशन तक पहुँची हों और साइन हुई हों।',
    'money.consultsCount_one': '{n} कंसल्टेशन',
    'money.consultsCount_other': '{n} कंसल्टेशन',
    'money.waitConsultMin': 'इंतज़ार / कंसल्टेशन (मिनट)',
    'money.topDiagnoses': 'सबसे आम निदान',
    'money.noDiagnoses': 'अभी तक कोई साइन किया हुआ निदान नहीं।',
    'money.topTests': 'सबसे ज़्यादा लिखे गए टेस्ट',
    'money.noTests': 'इस अवधि में कोई टेस्ट नहीं लिखा गया।',
    'money.topMedicines': 'सबसे ज़्यादा लिखी गई दवाइयाँ',
    'money.noMedicines': 'इस अवधि में कोई पर्चा नहीं।',
    'money.outstandingDues': 'बकाया राशि',
    'money.totalAmount': 'कुल {amount}',
    'money.nothingOwing': 'कुछ बकाया नहीं।',
    'money.ofAmount': '{amount} में से',
  },
  mr: {
    'money.collectedToday': 'आज जमा',
    'money.reconciliation': 'जुळवणी',
    'money.pendingN': '{n} बाकी',
    'money.dueAcross': 'भेटींवर {amount} बाकी',
    'money.viewBills': 'बिले पहा',
    'money.billing': 'बिलिंग',
    'money.raiseBill': 'बिल बनवा',
    'money.filter.owing': 'बाकी',
    'money.filter.draft': 'ड्राफ्ट',
    'money.filter.finalised': 'फायनल',
    'money.invStatus.draft': 'ड्राफ्ट',
    'money.invStatus.finalised': 'फायनल',
    'money.invStatus.void': 'रद्द',
    'money.outstanding': 'बाकी',
    'money.billsLabel_one': 'बिल',
    'money.billsLabel_other': 'बिले',
    'money.loadingBills': 'बिले लोड होत आहेत…',
    'money.noBills': 'इथे एकही बिल नाही.',
    'money.noBillsBody': 'सुरुवात करण्यासाठी एक बिल बनवा.',
    'money.rowTotal': 'एकूण {amount}',
    'money.rowPaid': 'भरले {amount}',
    'money.rowRefunded': 'रिफंड {amount}',
    'money.rowDue': 'बाकी {amount}',
    'money.couldNotLoadBills': 'बिले लोड होऊ शकली नाहीत.',
    'money.couldNotOpenBill': 'बिल उघडता आले नाही.',
    'money.items': 'आयटम',
    'money.tax': 'कर',
    'money.item': 'आयटम',
    'money.itemPh': 'कन्सल्टेशन, ड्रेसिंग, इंजेक्शन…',
    'money.quantity': 'संख्या',
    'money.rate': 'दर',
    'money.taxPct': 'कर %',
    'money.addLine': 'एक ओळ जोडा',
    'money.choosePatientFirst': 'आधी रुग्ण निवडा.',
    'money.couldNotRaise': 'बिल बनवता आले नाही.',
    'money.raising': 'बिल बनत आहे…',
    'money.raiseAsDraft': 'ड्राफ्ट म्हणून बनवा · {amount}',
    'money.change': 'बदला',
    'money.patientPh': 'नाव, मोबाइल किंवा रुग्ण कोड',
    'money.wholeBillDiscount': 'संपूर्ण बिलावर सवलत',
    'money.notNeeded': 'गरज नाही',
    'money.draftNote': 'हे ड्राफ्ट म्हणून बनले आहे. रुग्णाला वाचून दाखवा, मग फायनल करा — त्यानंतर रक्कम निश्चित होते आणि पैसे घेता येतात.',
    'money.pricingSaved': 'किमती सेव्ह झाल्या.',
    'money.couldNotSavePricing': 'किमती सेव्ह करता आल्या नाहीत.',
    'money.billFinalised': '{no} फायनल झाले.',
    'money.couldNotFinalise': 'बिल फायनल करता आले नाही.',
    'money.voidPrompt': 'हे बिल का रद्द केले जात आहे?',
    'money.billVoided': 'बिल रद्द झाले.',
    'money.couldNotVoid': 'बिल रद्द करता आले नाही.',
    'money.tookAmount': '{amount} घेतले.',
    'money.couldNotRecordPayment': 'पेमेंट नोंदवता आले नाही.',
    'money.refundedAmount': '{amount} रिफंड केले.',
    'money.couldNotRecordRefund': 'रिफंड नोंदवता आला नाही.',
    'money.savePricing': 'किमती सेव्ह करा',
    'money.editPricing': 'किमती बदला',
    'money.billDiscount': 'बिलावर सवलत',
    'money.billDiscountReason': 'बिलावर सवलत: {reason}',
    'money.voided': 'रद्द केले.',
    'money.voidedReason': 'रद्द केले: {reason}.',
    'money.lineLess': '{amount} वजा',
    'money.lineTax': 'कर {amount} ({rate}%)',
    'money.draftCannotPay': 'ड्राफ्टवर पैसे घेता येत नाहीत. पैसे घेण्यासाठी ते फायनल करा.',
    'money.finaliseBill': 'बिल फायनल करा',
    'money.voidBill': 'हे बिल रद्द करा',
    'money.received': 'मिळाले',
    'money.lessRefunded': '{amount} रिफंड वजा',
    'money.refund': 'रिफंड',
    'money.refunded': 'रिफंड केले',
    'money.noReason': 'कारण नोंदवलेले नाही',
    'money.settled': 'पूर्ण भरले',
    'money.refundNote': 'पावती कधीच बदलली जात नाही. रिफंड तिच्यासमोर वेगळी नोंद म्हणून नोंदवला जातो आणि बाकी तेवढ्या रकमेने पुन्हा उघडते.',
    'money.recordRefund': 'रिफंड नोंदवा',
    'money.takePayment': 'पेमेंट घ्या',
    'money.mode': 'पद्धत',
    'money.cashReceived': 'मिळालेली रोख',
    'money.referenceNo': 'रेफरन्स क्रमांक',
    'money.cashReceivedPh': 'रुग्णाने किती पैसे दिले',
    'money.referencePh': 'UTR, अप्रूव्हल कोड, चेक क्रमांक',
    'money.changeBack': 'परत द्यायचे सुटे: {amount}',
    'money.lessThanAmount': 'हे भरल्या जाणाऱ्या रकमेपेक्षा कमी आहे.',
    'money.partPayment': 'अंशतः पेमेंट. {amount} बाकी राहील.',
    'money.payAll': 'पूर्ण रक्कम',
    'money.recording': 'नोंद होत आहे…',
    'money.takeAmount': '{amount} घ्या',
    'money.dayEnd': 'दिवसाचा हिशोब',
    'money.reload': 'पुन्हा लोड करा',
    'money.couldNotLoadTally': 'हिशोब लोड होऊ शकला नाही.',
    'money.counting': 'मोजणी सुरू आहे…',
    'money.collected': 'कलेक्शन',
    'money.payments': 'पेमेंट',
    'money.inDrawer': 'ड्रॉवरमध्ये',
    'money.byMode': 'पेमेंट पद्धतीनुसार',
    'money.nothingCollectedDay': 'या दिवशी काहीही कलेक्शन झाले नाही.',
    'money.paymentsCount_one': '{n} पेमेंट',
    'money.paymentsCount_other': '{n} पेमेंट',
    'money.refundsCount_one': '{n} रिफंड',
    'money.refundsCount_other': '{n} रिफंड',
    'money.netOfRefunds': 'रिफंड वजा करून',
    'money.countDrawer': 'ड्रॉवर मोजा',
    'money.cashTaken': 'घेतलेली रोख',
    'money.cashRefunded': 'परत केलेली रोख',
    'money.shouldBeInDrawer': 'ड्रॉवरमध्ये असायला हवे',
    'money.countedInDrawer': 'ड्रॉवरमध्ये मोजलेले',
    'money.countedPh': 'नोटा मोजा आणि एकूण रक्कम लिहा',
    'money.drawerBalances': 'ड्रॉवरचा हिशोब जुळला.',
    'money.drawerOver': 'हिशोबापेक्षा {amount} जास्त. कधीच न बनवलेली पावती शोधा.',
    'money.drawerShort': '{amount} कमी. पावतीशिवाय दिलेले सुटे पैसे शोधा, किंवा नोंदवलेले पण न घेतलेले पेमेंट.',
    'money.drawerNote': 'कार्ड, UPI आणि नेट बँकिंगचा हिशोब ड्रॉवरशी नाही तर बँकेशी होतो, म्हणून ते वर दिसतात पण इथे मोजले जात नाहीत.',
    'money.reports': 'रिपोर्ट',
    'money.couldNotLoadReports': 'रिपोर्ट लोड होऊ शकले नाहीत.',
    'money.days7': '7 दिवस',
    'money.days30': '30 दिवस',
    'money.custom': 'तुमच्या तारखा',
    'money.from': 'पासून',
    'money.to': 'पर्यंत',
    'money.completedCount': '{n} पूर्ण',
    'money.newVsReturning': '{newPct}% नवीन · {retPct}% जुने',
    'money.byDoctor': 'डॉक्टरनुसार',
    'money.practice': 'प्रॅक्टिस',
    'money.dues': 'बाकी',
    'money.noVisitsRange': 'या कालावधीत एकही व्हिजिट नाही.',
    'money.visitsCount_one': '{n} व्हिजिट',
    'money.visitsCount_other': '{n} व्हिजिट',
    'money.paymentMix': 'पेमेंट पद्धती',
    'money.nothingCollectedYet': 'अजून काहीही कलेक्शन नाही.',
    'money.visitType': 'व्हिजिटचा प्रकार',
    'money.waitConsult': 'प्रतीक्षा आणि कन्सल्टेशन',
    'money.waitNote': 'पूर्ण झालेल्या व्हिजिटची सरासरी. प्रतीक्षा = आल्यापासून कन्सल्टेशन सुरू होईपर्यंत; कन्सल्टेशन = सुरू झाल्यापासून साइन होईपर्यंत.',
    'money.noTimings': 'अजून वेळा नाहीत — रिपोर्टसाठी कन्सल्टेशनपर्यंत पोहोचलेल्या आणि साइन झालेल्या व्हिजिट लागतात.',
    'money.consultsCount_one': '{n} कन्सल्टेशन',
    'money.consultsCount_other': '{n} कन्सल्टेशन',
    'money.waitConsultMin': 'प्रतीक्षा / कन्सल्टेशन (मिनिटे)',
    'money.topDiagnoses': 'सर्वाधिक निदान',
    'money.noDiagnoses': 'अजून साइन केलेले निदान नाही.',
    'money.topTests': 'सर्वाधिक सांगितलेल्या टेस्ट',
    'money.noTests': 'या कालावधीत एकही टेस्ट सांगितलेली नाही.',
    'money.topMedicines': 'सर्वाधिक लिहिलेली औषधे',
    'money.noMedicines': 'या कालावधीत एकही प्रिस्क्रिप्शन नाही.',
    'money.outstandingDues': 'बाकी रक्कम',
    'money.totalAmount': 'एकूण {amount}',
    'money.nothingOwing': 'काहीही बाकी नाही.',
    'money.ofAmount': '{amount} पैकी',
  },
  or: {
    'money.collectedToday': 'ଆଜି ଜମା',
    'money.reconciliation': 'ମେଳ',
    'money.pendingN': '{n} ବାକି',
    'money.dueAcross': 'ଭିଜିଟରେ {amount} ବାକି',
    'money.viewBills': 'ବିଲ୍ ଦେଖନ୍ତୁ',
    'money.billing': 'ବିଲିଂ',
    'money.raiseBill': 'ବିଲ୍ ତିଆରି କରନ୍ତୁ',
    'money.filter.owing': 'ବାକି',
    'money.filter.draft': 'ଡ୍ରାଫ୍ଟ',
    'money.filter.finalised': 'ଫାଇନାଲ୍',
    'money.invStatus.draft': 'ଡ୍ରାଫ୍ଟ',
    'money.invStatus.finalised': 'ଫାଇନାଲ୍',
    'money.invStatus.void': 'ବାତିଲ୍',
    'money.outstanding': 'ବାକି',
    'money.billsLabel_one': 'ବିଲ୍',
    'money.billsLabel_other': 'ବିଲ୍',
    'money.loadingBills': 'ବିଲ୍ ଲୋଡ୍ ହେଉଛି…',
    'money.noBills': 'ଏଠାରେ କୌଣସି ବିଲ୍ ନାହିଁ।',
    'money.noBillsBody': 'ଆରମ୍ଭ କରିବାକୁ ଗୋଟିଏ ବିଲ୍ ତିଆରି କରନ୍ତୁ।',
    'money.rowTotal': 'ମୋଟ {amount}',
    'money.rowPaid': 'ଦିଆଗଲା {amount}',
    'money.rowRefunded': 'ରିଫଣ୍ଡ {amount}',
    'money.rowDue': 'ବାକି {amount}',
    'money.couldNotLoadBills': 'ବିଲ୍ ଲୋଡ୍ ହୋଇପାରିଲା ନାହିଁ।',
    'money.couldNotOpenBill': 'ବିଲ୍ ଖୋଲିପାରିଲା ନାହିଁ।',
    'money.items': 'ଆଇଟମ୍',
    'money.tax': 'ଟିକସ',
    'money.item': 'ଆଇଟମ୍',
    'money.itemPh': 'କନସଲଟେସନ୍, ଡ୍ରେସିଂ, ଇଞ୍ଜେକସନ୍…',
    'money.quantity': 'ପରିମାଣ',
    'money.rate': 'ଦର',
    'money.taxPct': 'ଟିକସ %',
    'money.addLine': 'ଗୋଟିଏ ଧାଡ଼ି ଯୋଡ଼ନ୍ତୁ',
    'money.choosePatientFirst': 'ପ୍ରଥମେ ରୋଗୀ ବାଛନ୍ତୁ।',
    'money.couldNotRaise': 'ବିଲ୍ ତିଆରି ହୋଇପାରିଲା ନାହିଁ।',
    'money.raising': 'ବିଲ୍ ତିଆରି ହେଉଛି…',
    'money.raiseAsDraft': 'ଡ୍ରାଫ୍ଟ ଭାବେ ତିଆରି କରନ୍ତୁ · {amount}',
    'money.change': 'ବଦଳାନ୍ତୁ',
    'money.patientPh': 'ନାମ, ମୋବାଇଲ୍ କିମ୍ବା ରୋଗୀ କୋଡ୍',
    'money.wholeBillDiscount': 'ପୂରା ବିଲ୍ ଉପରେ ରିହାତି',
    'money.notNeeded': 'ଆବଶ୍ୟକ ନାହିଁ',
    'money.draftNote': 'ଏହା ଡ୍ରାଫ୍ଟ ଭାବେ ତିଆରି ହୋଇଛି। ରୋଗୀଙ୍କୁ ପଢ଼ି ଶୁଣାନ୍ତୁ, ତା’ପରେ ଫାଇନାଲ୍ କରନ୍ତୁ — ତା’ପରେ ରାଶି ସ୍ଥିର ହୋଇଯାଏ ଏବଂ ଦେୟ ନିଆଯାଇପାରିବ।',
    'money.pricingSaved': 'ଦାମ ସେଭ୍ ହେଲା।',
    'money.couldNotSavePricing': 'ଦାମ ସେଭ୍ ହୋଇପାରିଲା ନାହିଁ।',
    'money.billFinalised': '{no} ଫାଇନାଲ୍ ହେଲା।',
    'money.couldNotFinalise': 'ବିଲ୍ ଫାଇନାଲ୍ ହୋଇପାରିଲା ନାହିଁ।',
    'money.voidPrompt': 'ଏହି ବିଲ୍ କାହିଁକି ବାତିଲ୍ କରାଯାଉଛି?',
    'money.billVoided': 'ବିଲ୍ ବାତିଲ୍ ହେଲା।',
    'money.couldNotVoid': 'ବିଲ୍ ବାତିଲ୍ ହୋଇପାରିଲା ନାହିଁ।',
    'money.tookAmount': '{amount} ନିଆଗଲା।',
    'money.couldNotRecordPayment': 'ଦେୟ ରେକର୍ଡ ହୋଇପାରିଲା ନାହିଁ।',
    'money.refundedAmount': '{amount} ରିଫଣ୍ଡ କରାଗଲା।',
    'money.couldNotRecordRefund': 'ରିଫଣ୍ଡ ରେକର୍ଡ ହୋଇପାରିଲା ନାହିଁ।',
    'money.savePricing': 'ଦାମ ସେଭ୍ କରନ୍ତୁ',
    'money.editPricing': 'ଦାମ ବଦଳାନ୍ତୁ',
    'money.billDiscount': 'ବିଲ୍ ଉପରେ ରିହାତି',
    'money.billDiscountReason': 'ବିଲ୍ ଉପରେ ରିହାତି: {reason}',
    'money.voided': 'ବାତିଲ୍ କରାଗଲା।',
    'money.voidedReason': 'ବାତିଲ୍ କରାଗଲା: {reason}।',
    'money.lineLess': '{amount} କମ୍',
    'money.lineTax': 'ଟିକସ {amount} ({rate}%)',
    'money.draftCannotPay': 'ଡ୍ରାଫ୍ଟରେ ଦେୟ ନିଆଯାଇପାରିବ ନାହିଁ। ଦେୟ ନେବା ପାଇଁ ଏହାକୁ ଫାଇନାଲ୍ କରନ୍ତୁ।',
    'money.finaliseBill': 'ବିଲ୍ ଫାଇନାଲ୍ କରନ୍ତୁ',
    'money.voidBill': 'ଏହି ବିଲ୍ ବାତିଲ୍ କରନ୍ତୁ',
    'money.received': 'ମିଳିଲା',
    'money.lessRefunded': '{amount} ରିଫଣ୍ଡ ବାଦ୍',
    'money.refund': 'ରିଫଣ୍ଡ',
    'money.refunded': 'ରିଫଣ୍ଡ କରାଗଲା',
    'money.noReason': 'କୌଣସି କାରଣ ଲେଖାଯାଇନାହିଁ',
    'money.settled': 'ପୂରା ଦିଆଗଲା',
    'money.refundNote': 'ରସିଦ କେବେ ବଦଳାଯାଏ ନାହିଁ। ରିଫଣ୍ଡ ଏହା ବିରୁଦ୍ଧରେ ଅଲଗା ଏଣ୍ଟ୍ରି ଭାବେ ରେକର୍ଡ ହୁଏ ଏବଂ ବାକି ସେତିକି ରାଶିରେ ପୁଣି ଖୋଲିଯାଏ।',
    'money.recordRefund': 'ରିଫଣ୍ଡ ରେକର୍ଡ କରନ୍ତୁ',
    'money.takePayment': 'ଦେୟ ନିଅନ୍ତୁ',
    'money.mode': 'ମାଧ୍ୟମ',
    'money.cashReceived': 'ମିଳିଥିବା ନଗଦ',
    'money.referenceNo': 'ରେଫରେନ୍ସ ନମ୍ବର',
    'money.cashReceivedPh': 'ରୋଗୀ କେତେ ଟଙ୍କା ଦେଲେ',
    'money.referencePh': 'UTR, ଅନୁମୋଦନ କୋଡ୍, ଚେକ୍ ନମ୍ବର',
    'money.changeBack': 'ଫେରାଇବାକୁ ଥିବା ଖୁଚୁରା: {amount}',
    'money.lessThanAmount': 'ଏହା ଦିଆଯାଉଥିବା ରାଶିଠାରୁ କମ୍।',
    'money.partPayment': 'ଆଂଶିକ ଦେୟ। {amount} ବାକି ରହିବ।',
    'money.payAll': 'ପୂରା ରାଶି',
    'money.recording': 'ରେକର୍ଡ ହେଉଛି…',
    'money.takeAmount': '{amount} ନିଅନ୍ତୁ',
    'money.dayEnd': 'ଦିନର ହିସାବ',
    'money.reload': 'ପୁଣି ଲୋଡ୍ କରନ୍ତୁ',
    'money.couldNotLoadTally': 'ହିସାବ ଲୋଡ୍ ହୋଇପାରିଲା ନାହିଁ।',
    'money.counting': 'ଗଣନା ଚାଲିଛି…',
    'money.collected': 'କଲେକସନ୍',
    'money.payments': 'ଦେୟ',
    'money.inDrawer': 'ଡ୍ରୟରରେ',
    'money.byMode': 'ଦେୟ ମାଧ୍ୟମ ଅନୁସାରେ',
    'money.nothingCollectedDay': 'ଏହି ଦିନ କିଛି କଲେକସନ୍ ହୋଇନାହିଁ।',
    'money.paymentsCount_one': '{n}ଟି ଦେୟ',
    'money.paymentsCount_other': '{n}ଟି ଦେୟ',
    'money.refundsCount_one': '{n}ଟି ରିଫଣ୍ଡ',
    'money.refundsCount_other': '{n}ଟି ରିଫଣ୍ଡ',
    'money.netOfRefunds': 'ରିଫଣ୍ଡ ବାଦ୍ ଦେଇ',
    'money.countDrawer': 'ଡ୍ରୟର ଗଣନ୍ତୁ',
    'money.cashTaken': 'ନିଆଯାଇଥିବା ନଗଦ',
    'money.cashRefunded': 'ଫେରାଯାଇଥିବା ନଗଦ',
    'money.shouldBeInDrawer': 'ଡ୍ରୟରରେ ରହିବା କଥା',
    'money.countedInDrawer': 'ଡ୍ରୟରରେ ଗଣାଯାଇଥିବା',
    'money.countedPh': 'ନୋଟ୍ ଗଣି ମୋଟ ରାଶି ଲେଖନ୍ତୁ',
    'money.drawerBalances': 'ଡ୍ରୟରର ହିସାବ ମିଳିଗଲା।',
    'money.drawerOver': 'ହିସାବଠାରୁ {amount} ଅଧିକ। କେବେ ଲେଖାଯାଇନଥିବା ରସିଦ ଖୋଜନ୍ତୁ।',
    'money.drawerShort': '{amount} କମ୍। ରସିଦ ବିନା ଦିଆଯାଇଥିବା ଖୁଚୁରା, କିମ୍ବା ରେକର୍ଡ ହୋଇଥିବା କିନ୍ତୁ ନିଆଯାଇନଥିବା ଦେୟ ଖୋଜନ୍ତୁ।',
    'money.drawerNote': 'କାର୍ଡ, UPI ଏବଂ ନେଟ୍ ବ୍ୟାଙ୍କିଂର ହିସାବ ଡ୍ରୟର ସହିତ ନୁହେଁ, ବ୍ୟାଙ୍କ ସହିତ ହୁଏ, ତେଣୁ ସେଗୁଡ଼ିକ ଉପରେ ଦେଖାଯାଏ କିନ୍ତୁ ଏଠାରେ ଗଣାଯାଏ ନାହିଁ।',
    'money.reports': 'ରିପୋର୍ଟ',
    'money.couldNotLoadReports': 'ରିପୋର୍ଟ ଲୋଡ୍ ହୋଇପାରିଲା ନାହିଁ।',
    'money.days7': '7 ଦିନ',
    'money.days30': '30 ଦିନ',
    'money.custom': 'ନିଜ ତାରିଖ',
    'money.from': 'ଠାରୁ',
    'money.to': 'ପର୍ଯ୍ୟନ୍ତ',
    'money.completedCount': '{n}ଟି ସମ୍ପୂର୍ଣ୍ଣ',
    'money.newVsReturning': '{newPct}% ନୂଆ · {retPct}% ପୁରୁଣା',
    'money.byDoctor': 'ଡାକ୍ତର ଅନୁସାରେ',
    'money.practice': 'ପ୍ରାକ୍ଟିସ୍',
    'money.dues': 'ବାକି',
    'money.noVisitsRange': 'ଏହି ଅବଧିରେ କୌଣସି ଭିଜିଟ୍ ନାହିଁ।',
    'money.visitsCount_one': '{n}ଟି ଭିଜିଟ୍',
    'money.visitsCount_other': '{n}ଟି ଭିଜିଟ୍',
    'money.paymentMix': 'ଦେୟ ମାଧ୍ୟମ',
    'money.nothingCollectedYet': 'ଏପର୍ଯ୍ୟନ୍ତ କିଛି କଲେକସନ୍ ନାହିଁ।',
    'money.visitType': 'ଭିଜିଟ୍ ପ୍ରକାର',
    'money.waitConsult': 'ଅପେକ୍ଷା ଏବଂ କନସଲଟେସନ୍',
    'money.waitNote': 'ସମ୍ପୂର୍ଣ୍ଣ ଭିଜିଟ୍‌ର ହାରାହାରି। ଅପେକ୍ଷା = ପହଞ୍ଚିବାଠାରୁ କନସଲଟେସନ୍ ଆରମ୍ଭ ପର୍ଯ୍ୟନ୍ତ; କନସଲଟେସନ୍ = ଆରମ୍ଭଠାରୁ ସାଇନ୍ ପର୍ଯ୍ୟନ୍ତ।',
    'money.noTimings': 'ଏପର୍ଯ୍ୟନ୍ତ କୌଣସି ସମୟ ନାହିଁ — ରିପୋର୍ଟ ପାଇଁ କନସଲଟେସନ୍ ପର୍ଯ୍ୟନ୍ତ ପହଞ୍ଚି ସାଇନ୍ ହୋଇଥିବା ଭିଜିଟ୍ ଦରକାର।',
    'money.consultsCount_one': '{n}ଟି କନସଲଟେସନ୍',
    'money.consultsCount_other': '{n}ଟି କନସଲଟେସନ୍',
    'money.waitConsultMin': 'ଅପେକ୍ଷା / କନସଲଟେସନ୍ (ମିନିଟ୍)',
    'money.topDiagnoses': 'ସବୁଠାରୁ ଅଧିକ ରୋଗ ନିର୍ଣ୍ଣୟ',
    'money.noDiagnoses': 'ଏପର୍ଯ୍ୟନ୍ତ ସାଇନ୍ ହୋଇଥିବା ରୋଗ ନିର୍ଣ୍ଣୟ ନାହିଁ।',
    'money.topTests': 'ସବୁଠାରୁ ଅଧିକ ପରାମର୍ଶିତ ଟେଷ୍ଟ',
    'money.noTests': 'ଏହି ଅବଧିରେ କୌଣସି ଟେଷ୍ଟ ପରାମର୍ଶ ଦିଆଯାଇନାହିଁ।',
    'money.topMedicines': 'ସବୁଠାରୁ ଅଧିକ ଲେଖାଯାଇଥିବା ଔଷଧ',
    'money.noMedicines': 'ଏହି ଅବଧିରେ କୌଣସି ପ୍ରେସକ୍ରିପସନ୍ ନାହିଁ।',
    'money.outstandingDues': 'ବାକି ରାଶି',
    'money.totalAmount': 'ମୋଟ {amount}',
    'money.nothingOwing': 'କିଛି ବାକି ନାହିଁ।',
    'money.ofAmount': '{amount} ମଧ୍ୟରୁ',
  },
})
